import type { FallbackUrl } from '../../types';

/**
 * Utility function to extract the URL string from a `FallbackUrl` parameter.
 * Handles both string and function types.
 *
 * @param fallbackUrl - Either a string URL or a function that returns a string URL
 * @returns The URL as a string
 */
export const getFallbackUrl = (fallbackUrl: FallbackUrl): string => {
	if (typeof fallbackUrl === 'function') {
		return fallbackUrl();
	}

	// `fallbackUrl` is a string, return it directly
	return fallbackUrl;
};
